import { render, staticRenderFns } from "./reporte.vue?vue&type=template&id=52a29541&"
import script from "./reporte.component.ts?vue&type=script&lang=ts&"
export * from "./reporte.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports